import { QuotePdfType } from '@snap-types/models/enums';
import { PONQuoteDocument } from '@ui/features/quote-builder/components/PDF/SiteQuoteDocuments/pon';

import { ADFQuoteDocument } from './adf';
import { AMFQuoteDocument } from './amf';
import { ANAQuoteDocument } from './ana';
import { ASMQuoteDocument } from './asm';
import { BTLQuoteDocument } from './btl';
import { CAPQuoteDocument } from './cap';
import { CSCQuoteDocument } from './csc';
import { CSCCustomQuoteDocument } from './csc_custom';
import { DefaultQuoteDocument } from './default';
import { GREQuoteDocument } from './gre';
import { HPCQuoteDocument } from './hpc';
import { MMCQuoteDocument } from './mmc';
import { MWSQuoteDocument } from './mws';
import { MWSHypercoQuoteDocument } from './mws-hyperco';
import { RAFQuoteDocument } from './raf';
import { ROCQuoteDocument } from './roc';
import { SPMQuoteDocument } from './spm';
import { USAQuoteDocument } from './usa';
import { WWPQuoteDocument } from './wwp';

export const siteQuoteDocuments: Record<QuotePdfType, React.ComponentType> = {
  [QuotePdfType.ADF]: ADFQuoteDocument,
  [QuotePdfType.AMF]: AMFQuoteDocument,
  [QuotePdfType.ANA]: ANAQuoteDocument,
  [QuotePdfType.ASM]: ASMQuoteDocument,
  [QuotePdfType.BTL]: BTLQuoteDocument,
  [QuotePdfType.CAP]: CAPQuoteDocument,
  [QuotePdfType.CSC]: CSCQuoteDocument,
  [QuotePdfType.CSC_CUSTOM]: CSCCustomQuoteDocument,
  [QuotePdfType.DEFAULT]: DefaultQuoteDocument,
  [QuotePdfType.GRE]: GREQuoteDocument,
  [QuotePdfType.HPC]: HPCQuoteDocument,
  [QuotePdfType.MMC]: MMCQuoteDocument,
  [QuotePdfType.MWS]: MWSQuoteDocument,
  [QuotePdfType.MWS_HYPERCO]: MWSHypercoQuoteDocument,
  [QuotePdfType.PON]: PONQuoteDocument,
  [QuotePdfType.RAF]: RAFQuoteDocument,
  [QuotePdfType.ROC]: ROCQuoteDocument,
  [QuotePdfType.SPM]: SPMQuoteDocument,
  [QuotePdfType.USA]: USAQuoteDocument,
  [QuotePdfType.WWP]: WWPQuoteDocument,
};
